import { render } from "./Footer.vue?vue&type=template&id=2f4076ec&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=2f4076ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f4076ec"]])

export default __exports__